import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getInfoByType } from 'services/info';
import { homeBannerSettings } from 'config/settingsSlider';
import Info from 'services/info/models/info-interface';
import { SectionContainer } from 'components/Container';
import SliderDefault from 'components/SliderDefault';

import { BannerWrapper } from './style';

const Banners: React.FC = () => {
  const [banners, setBanners] = useState<Array<Info>>([]);

  useEffect(() => {
    (async () => {
      const localBanners = await getInfoByType('HOME_IMAGE');

      setBanners(localBanners);
    })();
  }, []);

  return (
    <SectionContainer>
      <BannerWrapper>
        <SliderDefault settings={homeBannerSettings}>
          {banners &&
            banners.length &&
            banners.map((data, index) => {
              if (Object.keys(data.info).includes('link')) {
                const regex =
                  /(onde-comprar|profissionais|termos|privacidade|faq|meus-cursos|trilha|produtos|fale-conosco)/i;
                const isInternal = data.info.link?.match(regex);

                if (isInternal) {
                  const index = data.info.link.indexOf(isInternal[0]);
                  const newLink = data.info.link.substring(index);

                  return (
                    <Link to={newLink}>
                      <div key={`banner-${index}`}>
                        <img
                          className="banner-image"
                          src={data.info.image_url}
                          alt="banner"
                        />
                      </div>
                    </Link>
                  );
                } else {
                  return (
                    <a target="_blank" href={data.info.link}>
                      <div key={`banner-${index}`}>
                        <img
                          className="banner-image"
                          src={data.info.image_url}
                          alt="banner"
                        />
                      </div>
                    </a>
                  );
                }
              }

              return (
                <div key={`banner-${index}`}>
                  <img
                    className="banner-image"
                    src={data.info.image_url}
                    alt="banner"
                  />
                </div>
              );
            })}
        </SliderDefault>
      </BannerWrapper>
    </SectionContainer>
  );
};

export default Banners;
